import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/appVersion/distribution/appVersion.distribution.query.gql"
import type {
  AppVersionDistributionQuery,
  AppVersionDistributionQueryVariables,
} from "@/v2-backoffice-client/appVersion/distribution/__types__/appVersion.distribution.query"

type Options = QueryHookOptions<
  AppVersionDistributionQuery,
  AppVersionDistributionQueryVariables
>

export function useAppVersionDistributionQuery(options?: Options) {
  return useQuery<
    AppVersionDistributionQuery,
    AppVersionDistributionQueryVariables
  >(query, options)
}
